/**
=========================================================
* Otis Kit PRO - v2.0.2
=========================================================

* Product Page: https://material-ui.com/store/items/otis-kit-pro-material-kit-react/
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect } from 'react';

// react-router components
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

// @mui material components
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Otis Kit PRO themes
import theme from 'assets/theme';

// Otis Kit PRO routes
import routes from 'routes';
import AboutUsPage from 'layouts/pages/company/about-us';
import AOS from 'aos';
import 'aos/dist/aos.css';
import store from './redux/store';
import { Provider } from 'react-redux';

import Postulacion from 'pages/Postulation';

export default function App() {
  const { pathname, hash, state } = useLocation();

  // Setting page scroll to 0 when changing the route, or scrolling to hash if present
  useEffect(() => {
    AOS.init({
      duration: 500,
      once: true,
    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      AOS.refresh();
      // Verificamos si hay hash (e.g. #contact-us) o si venimos con un state.scrollTo (ej. desde el footer)
      const idToScroll = hash ? hash.replace('#', '') : state?.scrollTo || null;

      if (idToScroll) {
        const element = document.getElementById(idToScroll);
        if (element) {
          const elementPosition = element.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: elementPosition - 100, // Ajuste para navbar y carga de imágenes
            behavior: 'smooth',
          });
        }
      }
    }, 800); // 800ms da un poco más de tiempo a los componentes pesados para montar

    if (!hash && (!state || !state.scrollTo)) {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
    }
  }, [pathname, hash, state]);

  // const getRoutes = (allRoutes) =>
  //   allRoutes.map((route, index) => {
  //     if (route.collapse) {
  //       return getRoutes(route.collapse);
  //     }

  //     if (route.route) {
  //       return <Route exact path={route.route} element={route.component} key={route.key} />;
  //     }

  //     return null;
  //   });

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Routes>
          {/* {getRoutes(routes)} */}
          <Route path="/" element={<AboutUsPage />} />
          <Route path="/AboutUs" element={<AboutUsPage />} />
          <Route path="/Postulation" element={<Postulacion />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </ThemeProvider>
    </Provider>
  );
}
